export default [
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/error/Error404.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/pages/authentication/Login.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
      showMessageBox: false,
    },
  },
  {
    path: '/onboarding-form',
    name: 'global-onboardingForm',
    component: () => import('@/views/pages/onboarding/CustomerOnboarding.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/onboarding-waiting',
    name: 'global-onboardingWaiting',
    component: () => import('@/views/pages/onboarding/OnboardingWaiting.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/campaign-labelling',
    name: 'settings-labelling',
    component: () => import('@/views/campaign-labelling/Labelling.vue'),
    children: [
      {
        path: '/campaign-labelling-holistic',
        name: 'settings-labelling-holistic',
        component: () => import('@/views/campaign-labelling/holistic/Index.vue'),
      },
      {
        path: '/campaign-labelling-campaign',
        name: 'settings-labelling-campaign',
        component: () => import('@/views/campaign-labelling/campaign/Index.vue'),
      },
      {
        path: '/campaign-labelling-kpi-target',
        name: 'settings-labelling-kpiTarget',
        component: () => import('@/views/campaign-labelling/kpi-target/Index.vue'),
      },
    ]
  },
  {
    path:'/consent',
    name: 'global-consent',
    component: () => import('@/views/consent/Index.vue'),
    meta: {
      layout: 'full',
      showMessageBox: false,
    },
  },
]
